module.exports = __webpack_public_path__ + "static/media/homeArchitect.f13c17a6.svg";